"use client";

import { HomeCtaSection } from "./components/HomeCtaSection";
import { HomeExperienceSection } from "./components/HomeExperienceSection";
import { HomeFaqSection } from "./components/HomeFaqSection";
import { HomeHeroSection } from "./components/HomeHeroSection";
import { HomeIndustriesSection } from "./components/HomeIndustriesSection";
import { HomeMarqueeSection } from "./components/HomeMarqueeSection";
import { HomeServicesSection } from "./components/HomeServicesSection";
import { HomeTestimonialsSection } from "./components/HomeTestimonialsSection";
import { HomeWhyChooseUsSection } from "./components/HomeWhyChooseUsSection";

// * ─── Home Page ──────────────────────────────────────────────────────────────
// Orchestrates all sections in order. Each section is self-contained.
export function HomePage() {
  return (
    <div className="overflow-hidden">
      <HomeHeroSection />
      <HomeMarqueeSection variant="forward" />
      <HomeMarqueeSection variant="reverse" />
      <HomeExperienceSection />
      <HomeServicesSection />
      <HomeWhyChooseUsSection />
      <HomeIndustriesSection />
      <HomeTestimonialsSection />
      <HomeCtaSection />
      <HomeFaqSection />
    </div>
  );
}
